import React from 'react';
import * as FaIcons from 'react-icons/fa';

// Type assertion helper for Font Awesome icons
const createIcon = (IconComponent: any) => (props: any) => {
  return React.createElement(IconComponent, props);
};

// Export properly typed icon components
export const FaSearch = createIcon(FaIcons.FaSearch);
export const FaFilter = createIcon(FaIcons.FaFilter);
export const FaWhatsapp = createIcon(FaIcons.FaWhatsapp);
export const FaStar = createIcon(FaIcons.FaStar);
export const FaShieldAlt = createIcon(FaIcons.FaShieldAlt);
export const FaRocket = createIcon(FaIcons.FaRocket);
export const FaPhoneAlt = createIcon(FaIcons.FaPhoneAlt);
export const FaCrown = createIcon(FaIcons.FaCrown);
export const FaMagic = createIcon(FaIcons.FaMagic);
export const FaCalculator = createIcon(FaIcons.FaCalculator);
export const FaGem = createIcon(FaIcons.FaGem);
export const FaBars = createIcon(FaIcons.FaBars);
export const FaTimes = createIcon(FaIcons.FaTimes);
export const FaPhone = createIcon(FaIcons.FaPhone);
export const FaEnvelope = createIcon(FaIcons.FaEnvelope);
export const FaMapMarkerAlt = createIcon(FaIcons.FaMapMarkerAlt);
export const FaClock = createIcon(FaIcons.FaClock);
export const FaStore = createIcon(FaIcons.FaStore);
export const FaHandshake = createIcon(FaIcons.FaHandshake);
export const FaCheckCircle = createIcon(FaIcons.FaCheckCircle);
export const FaUserCheck = createIcon(FaIcons.FaUserCheck);
export const FaCreditCard = createIcon(FaIcons.FaCreditCard);
export const FaUser = createIcon(FaIcons.FaUser);
export const FaLock = createIcon(FaIcons.FaLock);
export const FaEye = createIcon(FaIcons.FaEye);
export const FaEyeSlash = createIcon(FaIcons.FaEyeSlash);
export const FaGoogle = createIcon(FaIcons.FaGoogle);
export const FaFacebook = createIcon(FaIcons.FaFacebook);
export const FaChevronDown = createIcon(FaIcons.FaChevronDown);
export const FaChevronUp = createIcon(FaIcons.FaChevronUp);
export const FaChevronLeft = createIcon(FaIcons.FaChevronLeft);
export const FaChevronRight = createIcon(FaIcons.FaChevronRight);
export const FaPlay = createIcon(FaIcons.FaPlay);
export const FaGlobe = createIcon(FaIcons.FaGlobe);
export const FaUndo = createIcon(FaIcons.FaUndo);
export const FaPlus = createIcon(FaIcons.FaPlus);
export const FaEdit = createIcon(FaIcons.FaEdit);
export const FaTrash = createIcon(FaIcons.FaTrash);
export const FaSave = createIcon(FaIcons.FaSave);
export const FaCheck = createIcon(FaIcons.FaCheck);
export const FaArrowRight = createIcon(FaIcons.FaArrowRight);
export const FaUserShield = createIcon(FaIcons.FaUserShield);
export const FaHeadset = createIcon(FaIcons.FaHeadset);
export const FaTruck = createIcon(FaIcons.FaTruck);
export const FaMoneyBillWave = createIcon(FaIcons.FaMoneyBillWave);
export const FaHeart = createIcon(FaIcons.FaHeart);
export const FaCog = createIcon(FaIcons.FaCog);
export const FaImage = createIcon(FaIcons.FaImage);
export const FaInstagram = createIcon(FaIcons.FaInstagram);
export const FaGripVertical = createIcon(FaIcons.FaGripVertical);
export const FaArrowUp = createIcon(FaIcons.FaArrowUp);
export const FaArrowDown = createIcon(FaIcons.FaArrowDown);
export const FaTag = createIcon(FaIcons.FaTag);
export const FaUpload = createIcon(FaIcons.FaUpload);
export const FaCar = createIcon(FaIcons.FaCar);
export const FaMoneyBill = createIcon(FaIcons.FaMoneyBill);
export const FaCoins = createIcon(FaIcons.FaCoins);
export const Fa4 = createIcon(FaIcons.FaRegWindowRestore); // Using as placeholder for 4
export const Fa5 = createIcon(FaIcons.FaRegWindowMaximize); // Using as placeholder for 5
export const Fa6 = createIcon(FaIcons.FaRegWindowMinimize); // Using as placeholder for 6
